export const SET_MAIN_DOCUMENT = 'SET_MAIN_DOCUMENT';

export const setMainDocument = (document, error, loading) => ({
  type: SET_MAIN_DOCUMENT,
  payload: { document, error, loading },
});
